import { Fragment, useCallback } from 'react';

import Analytics from '@hh.ru/analytics-js';
import { Link } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import Conversion from 'bloko/blocks/conversion';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { ConnectedServiceList, ConnectedServiceTypes } from 'src/models/candidatesList';
import { REGULAR_SPACE } from 'src/utils/constants/symbols';

import ConnectedServicesInfotip from 'src/components/ResumeCard/Header/CommunicationStatusList/ConnectedServices/Infotip';

const LINK_HREF = 'https://clickme.hh.ru/new/dashboard';

const TrlKeys = {
    one: 'negotiations.employer.connectedServices.one',
    many: 'negotiations.employer.connectedServices.many',
};

interface Props {
    isFirstResponse: boolean;
    collection: ConnectedServiceList;
}

const ConnectedServices: TranslatedComponent<Props> = ({ isFirstResponse, collection, trls }) => {
    const sendEventElementShown = useCallback(
        (element: HTMLDivElement) => {
            if (element) {
                Analytics.sendEventElementShown(
                    element,
                    'employer',
                    'show-connected-services-text',
                    collection.map(({ name }) => name).join()
                );
            }
        },
        [collection]
    );

    return (
        <span>
            <Conversion
                hasValue={false}
                many={trls[TrlKeys.many]}
                one={trls[TrlKeys.one]}
                some={trls[TrlKeys.many]}
                value={collection.length}
            />
            {REGULAR_SPACE}
            <ConnectedServicesInfotip isFirstResponse={isFirstResponse}>
                <span ref={sendEventElementShown}>
                    {collection.map(({ name, trl }, index) => {
                        const isClickme = [
                            ConnectedServiceTypes.Clickme,
                            ConnectedServiceTypes.ClickmeSearchAuction,
                        ].includes(name);

                        return (
                            <Fragment key={name}>
                                {index !== 0 && <span>{', '}</span>}
                                {isClickme ? (
                                    <Link
                                        Element={SPALink}
                                        to={LINK_HREF}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() =>
                                            Analytics.sendEvent('employer', 'click-connected-services-item', name)
                                        }
                                        style="accent"
                                        typography="label-3-regular"
                                        inline
                                    >
                                        {trl}
                                    </Link>
                                ) : (
                                    trl
                                )}
                            </Fragment>
                        );
                    })}
                </span>
            </ConnectedServicesInfotip>
        </span>
    );
};

export default translation(ConnectedServices);
